import { render } from "./Forms.vue?vue&type=template&id=7b83f254&scoped=true&lang=true"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"

import "./Forms.vue?vue&type=style&index=0&id=7b83f254&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b83f254"

export default script